"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse2OpenFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.Collapse2OpenFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M1 3.25C1 2.55964 1.55964 2 2.25 2H5.75C6.44036 2 7 2.55964 7 3.25V12.75C7 13.4404 6.44036 14 5.75 14H2.25C1.55964 14 1 13.4404 1 12.75V3.25ZM9.20474 3.23503C8.92033 3.53617 8.93389 4.01085 9.23503 4.29526L12.3636 7.25H8.75C8.33579 7.25 8 7.58579 8 8C8 8.41421 8.33579 8.75 8.75 8.75H12.3636L9.23503 11.7047C8.93389 11.9891 8.92033 12.4638 9.20474 12.765C9.48915 13.0661 9.96383 13.0797 10.265 12.7953L14.7637 8.54642C14.9092 8.40962 15 8.21542 15 8C15 7.78458 14.9092 7.59038 14.7637 7.45358L10.265 3.20474C9.96383 2.92033 9.48915 2.93389 9.20474 3.23503Z", fill: colors[0], fillRule: "evenodd", clipRule: "evenodd" }));
    },
    name: 'collapse_2_open_filled',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M1 3.25C1 2.55964 1.55964 2 2.25 2H5.75C6.44036 2 7 2.55964 7 3.25V12.75C7 13.4404 6.44036 14 5.75 14H2.25C1.55964 14 1 13.4404 1 12.75V3.25ZM9.20474 3.23503C8.92033 3.53617 8.93389 4.01085 9.23503 4.29526L12.3636 7.25H8.75C8.33579 7.25 8 7.58579 8 8C8 8.41421 8.33579 8.75 8.75 8.75H12.3636L9.23503 11.7047C8.93389 11.9891 8.92033 12.4638 9.20474 12.765C9.48915 13.0661 9.96383 13.0797 10.265 12.7953L14.7637 8.54642C14.9092 8.40962 15 8.21542 15 8C15 7.78458 14.9092 7.59038 14.7637 7.45358L10.265 3.20474C9.96383 2.92033 9.48915 2.93389 9.20474 3.23503Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
